import { ServiceBase } from '../../../../../core/services/ServiceBase'
import ReportProxy from './ReportProxy'

class ReportService extends ServiceBase {
  getSampleReport(params) {
    return this.getFileDownload(() => ReportProxy.getSampleReport(params))
  }

  getReportItems(params) {
    return this.getData(() => ReportProxy.getReportItems(params))
  }
}

export default new ReportService()
